import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Nhập mật khẩu cũ", -1)
const _hoisted_4 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Nhập mật khẩu mới(tối thiểu 6 ký tự)", -1)
const _hoisted_6 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Nhập lại mật khẩu mới", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Password = _resolveComponent("Password")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Cập nhật mật khẩu" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_Password, {
            id: "passwordOld",
            modelValue: $setup.passwordOld,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.passwordOld) = $event)),
            toggleMask: "",
            feedback: true
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_Password, {
            id: "password1",
            modelValue: $setup.password1,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.password1) = $event)),
            toggleMask: "",
            feedback: true
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_Password, {
            id: "password2",
            modelValue: $setup.password2,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.password2) = $event)),
            toggleMask: "",
            feedback: true
          }, null, 8, ["modelValue"])
        ])
      ]),
      ($setup.valid)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            label: "Cập nhật",
            icon: "pi pi-plus-circle",
            iconPos: "left",
            style: {"margin-bottom":"20px"},
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.doUpdate()))
          }))
        : (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            label: "Cập nhật",
            icon: "pi pi-plus-circle",
            iconPos: "left",
            style: {"margin-bottom":"20px"},
            disabled: "disabled"
          }))
    ]),
    _: 1
  }))
}